import _ from 'lodash'
import { List } from 'immutable'
import { buildBulkdSFPush, processWidgetCustomSFPushItem } from './actions'

export const processWidgetCustomSFPush = (state, conf, isPortal) => async (dispatch) => {
  let status = true
  let sfPush = state.getIn(['project', 'Settings', 'pushToSalesforce'], List()).toJS()
  let sfPushConf
  if (conf.isBulk) {
    sfPushConf = buildBulkdSFPush(conf, sfPush)
  } else {
    sfPushConf = _.find(sfPush, (push) => push.uid === conf.value)
  }
  if (sfPushConf !== false) {
    const result = await processWidgetCustomSFPushItem(state, sfPushConf, conf, dispatch, null, isPortal)
    return result
  }
  return {
    status,
  }
}
